import { LayoutGrid, ListTree } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/app/components/ui/button';
import type { MediaViewMode } from '../../../types';

interface MediaViewModeToggleProps {
  value: MediaViewMode;
  onChange: (mode: MediaViewMode) => void;
}

export const MediaViewModeToggle = ({ value, onChange }: MediaViewModeToggleProps) => {
  const t = useTranslations();
  const nextMode: MediaViewMode = value === 'grid' ? 'tree' : 'grid';
  const Icon = value === 'grid' ? ListTree : LayoutGrid;
  const label = t(`claw.assets.viewMode.${nextMode}`);

  return (
    <Button
      variant="text"
      size="sm"
      className="rounded-10 px-2 text-system-white40 hover:bg-system-white08 hover:text-system-white"
      title={label}
      aria-label={label}
      onClick={() => onChange(nextMode)}
    >
      <Icon className="size-4" />
    </Button>
  );
};
